import React from 'react'
import MaterialSymbol from '../material-symbol'

const Info = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="info" {...props} />
))

Info.displayName = 'Info'

export default Info
